<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle">acknowledgments</h2>
<p class="noindent">Seven years ago, my friend Michael Hyatt encouraged me to write a book—a book that would be a message of hope and healing to more than just one patient at a time. Seven years later, you are holding the final product of a true labor of love. I hope you love it as much as I do. I am a living example of how you can reverse the disease process. I want you to know that you are NOT broken, you were NEVER broken, and your body is designed to heal itself. You simply need a plan, and I have that for you.</p>
<p class="noindent">This book would not be possible without so many people, too many to mention:</p>
<p class="noindent">To my four best friends that I have had for decades, who are the true definition of community. Margo, Trish, Kim, and Billie—you are the roots that keep me standing and hold me accountable.</p>
<p class="noindent">To my incredible office staff that is truly a “dream team.”</p>
<p class="noindent">To my community in Middle Tennessee that show up, show out, and share your life with me.</p>
<p class="noindent">To Jen Lill Brown for putting my words so beautifully to paper and pressing on to get this book to print.</p>
<p class="noindent">To Morgan James Publishing for taking a chance on an unknown author. I won’t let you down.</p>
<p class="noindent">To Mom, your life was never easy. Alzheimer’s has taken its toll on you. I wish we could have known each other better. I will make the most of whatever time we have left to learn about each other.</p>
<p class="noindent">To Dad and DeeDee, let’s get the RV geared up for the Wild &amp; Well Book Tour! Thanks for always being there for me.</p>
<p class="noindent">Hang in there, ladies and gentlemen, because the best is yet to come! You got this.</p>
<p class="noindent">Stay Wild &amp; Well,</p>
<p class="noindent"><img alt="" src="images/fig3.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?75bf7d38